module.exports = __webpack_public_path__ + "img/message.2aff6093.gif";